import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import { PlansData, SimpleAccordionData } from '../../common/classes';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-plan-selection-box',
  templateUrl: './plan-selection-box.component.html',
  styleUrls: ['./plan-selection-box.component.scss']
})
export class PlanSelectionBoxComponent implements OnInit {
  @Output() selectPlanMethod: EventEmitter<PlansData> = new EventEmitter();
  @Output() changePlanMethod: EventEmitter<PlansData> = new EventEmitter();
  @Output() cancelPlanMethod: EventEmitter<PlansData> = new EventEmitter();
  @Input() data: PlansData
  @Input() disableButtons: boolean;
  @Input() selectMode: boolean;
  @Input() reviewMode: boolean;
  @Input() manageMode: boolean;
  @Input() dropdownsData: SimpleAccordionData[];
  
  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
  }

  public onChangePlanMethod() {
    this.changePlanMethod.emit()
  }

  public onCancelPlanMethod() {
    this.router.navigate(['cancel', 'cancel-plan'], {skipLocationChange: true})
  }

  public onSelectPlanMethod() {
    this.selectPlanMethod.emit(this.data)
  }
}
